module.exports = __webpack_public_path__ + "img/home-title-tw-mobile.2449d490.svg";